'use client';

import React from 'react';
import cn from 'classnames';
import { usePathname } from '@framework/next/navigation';
import config from '@/dataroom/app/config/config';
import dataroomUrl from '@/dataroom/infrastructure/dataroomUrl';
import dmPortalUrl from '@dm-portal/url';
import DataroomTenantContext from '@dataroom/tenant/DataroomTenantContext';
import ScrollBodyBackground from '@framework/ui/Templates/ScrollBodyBackground';
import Header from '@framework/ui/Pages/Landing/Legacy/Sections/Header';
import BookDemoButton from '@/dataroom/ui/common/BookDemoButton';
import CookiesBanner from '@framework/cookie-consent/CookiesBanner';
import useLoginUrlWithConsent from '@framework/cookie-consent/useLoginUrlWithConsent';
import Footer from './Footer';
import stickyFooterStyles from '@framework/ui/Organisms/StickyFooter/stickyFooter.module.scss';
import headerStyles from '@framework/ui/Pages/Landing/Legacy/Sections/Header/header.module.scss';
import styles from './tenantInvestorSet.module.scss';
import logo from '@/dataroom/ui/assets/investorSetLogoText.svg';

interface IProps {
  children: React.ReactNode,
}

const getHeaderMenu = (pathname: string) => [
  {
    key: 'how-it-works',
    title: 'How it Works',
    path: '/how-it-works',
  },
  {
    key: 'explore-sets',
    title: 'Explore Sets',
    path: '/explore-sets/all',
    isActive: () => pathname.startsWith('/explore-sets'),
  },
  {
    key: 'pricing',
    title: 'Pricing',
    path: '/pricing',
  },
];

const TenantInvestorSet = ({ children }: IProps) => {
  const tenant = config.tenant.tenantInvestorSet.code;
  const pathname = usePathname();

  const loginUrl = useLoginUrlWithConsent(() =>
    dataroomUrl(tenant).getLoginUrl(dmPortalUrl.getUrl(`/${ tenant }`)),
  );

  const registerUrl = dataroomUrl(tenant).getRegisterUrl(
    dataroomUrl(tenant).getUrl(pathname),
  );

  return (
    <DataroomTenantContext tenant={ tenant }>
      <Header
        tenant={ tenant }
        logo={ logo.src }
        menu={ getHeaderMenu(pathname) }
        isWideMenu
        button={ () => (
          <BookDemoButton legacy className={ headerStyles.menuBtn } />
        ) }
        loginUrl={ loginUrl }
        registerUrl={ registerUrl }
      />
      <div className={ cn(styles.pageContainer, stickyFooterStyles.pageContainerWithStickyFooter) }>
        <ScrollBodyBackground tenant={ tenant } />
        { children }
      </div>
      <Footer tenant={ tenant } />
      <CookiesBanner />
    </DataroomTenantContext>
  );
};

export default TenantInvestorSet;
